@let _subscriptionCountText = subscriptionCountText();

@if (_subscriptionCountText) {
  <div class="subscriptions-count">
    <span [innerHTML]="_subscriptionCountText" class="subscriptions-count__text" data-hook="subscription-count-text"></span>
    <button class="subscriptions-count__link" [routerLink]="'/subscriptions'" data-testid="link-my-subscription-top">
      <span>Subscribe</span>
      <grid-ui-icon class="subscriptions-count__icon" name="share" [useInlineSVG]="true"></grid-ui-icon>
    </button>
  </div>
} @else {
  <grid-ui-loading class="subscription_loading" message="" data-hook="subscription-count-loading"></grid-ui-loading>
}
